import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';
import { ImagingSettingsClient } from 'business/models/Models';

export default class ImagingSettingsService extends BaseService {
  async getRobots() {
    const imagingSettingsClient: ImagingSettingsClient = ModelFactory(
      ImagingSettingsClient,
      false,
      true,
    );
    return await imagingSettingsClient.getRobots();
  }
}
